import {memo} from 'react';
import {StatusText} from '~/ViewInvitation/components/Guestlist/List/StatusText';
import {type Guest, GuestType} from '~/ViewInvitation/types/guests';
import {Typography} from '~library/atoms/Typography';
import {CrownIcon} from '~library/svg/v2/CrownIcon';
import {UserIcon} from '~library/svg/v2/UserIcon';

import * as styles from './Details.module.scss';

const hostBadge = (
  <Typography variant="paragraph3" className={styles.badge} data-qa-id="host-badge">
    <UserIcon ratio={0.5} /> Host
  </Typography>
);

const cohostBadge = (
  <Typography variant="paragraph3" className={styles.badge} data-qa-id="cohost-badge">
    <UserIcon ratio={0.5} /> Co-host
  </Typography>
);

const gohBadge = (
  <Typography variant="paragraph3" className={styles.badge} data-qa-id="goh-badge">
    <CrownIcon ratio={0.5} /> Guest of honor
  </Typography>
);

const Comment = memo(({comment}: {comment: string}) => {
  return (
    <Typography
      variant="paragraph3"
      className={styles.comment}
      data-qa-id="guest-comment"
      data-qa-value={comment}
    >
      {comment}
    </Typography>
  );
});

Comment.displayName = 'Comment';

interface DetailsProps {
  guest: Guest;
}

export const Details = memo(({guest}: DetailsProps) => (
  <div className={styles.nameColumn}>
    <Typography variant="paragraph2" data-qa-id="guest-name" data-qa-value={guest.name}>
      {guest.name}
    </Typography>
    {guest.guestType === GuestType.HOST && hostBadge}
    {guest.guestType === GuestType.COHOST && cohostBadge}
    {guest.guestType === GuestType.GUEST_OF_HONOR && gohBadge}
    <StatusText guest={guest} />
    {guest.comment && <Comment comment={guest.comment} />}
  </div>
));

Details.displayName = 'Details';
